import { axios, getConfigs, IRequestConfig, SiteDto } from './api'
import { HospitalUnitType } from './dtos'
import { PaginatedDto } from './extendedType'

export enum CareTypeEnum {
  Outpatient = 'OUTPATIENT',
  Inpatient = 'INPATIENT',
  Ambulatory = 'AMBULATORY',
}

export interface FunctionalUnitFilters {
  search?: string
  functionType?: HospitalUnitType
}

export interface FunctionalUnitDTO {
  id: number
  name: string
  number: string
  siteId: number
  site: SiteDto
  label: string
  careType: CareTypeEnum
  isExecutingUnit?: boolean
  isRequestingUnit?: boolean
  functionType: HospitalUnitType
  functionSubType: string
  details?: MedicalUnitDetails
  serviceManagerName?: string
}

export interface MedicalUnitDetails {
  authorizationDate?: Date
  authorizationEndDate: Date
  authorizationNumber: string
  authorizationType?: string
  dedicatedBedsCount: number
  dedicatedBedType?: string
  hospitalizationMode?: 'MIXED' | 'COMPLETE' | 'PARTIAL'
}

export interface CreateFunctionalUnitDTO {
  name: string
  number: string
  siteId: number
  label?: string
  careType: CareTypeEnum
  isExecutingUnit: boolean
  isRequestingUnit: boolean
  functionType?: HospitalUnitType | null
  functionSubType?: string | null
  serviceManagerName?: string
  details?: MedicalUnitDetails | null
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UpdateFunctionalUnitDTO
  extends Partial<CreateFunctionalUnitDTO> {}

export class FunctionalUnitService {
  private static readonly endpoint = 'functional-unit'

  static getAll(
    query: FunctionalUnitFilters,
  ): Promise<PaginatedDto<FunctionalUnitDTO>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        this.endpoint,
        {},
      )
      configs.params = query
      axios(configs, resolve, reject)
    })
  }

  static findOne(id: number): Promise<FunctionalUnitDTO> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )
      axios(configs, resolve, reject)
    })
  }

  static create(
    createFunctionalUnitDto: CreateFunctionalUnitDTO,
  ): Promise<FunctionalUnitDTO> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        this.endpoint,
        {},
      )
      configs.data = createFunctionalUnitDto
      axios(configs, resolve, reject)
    })
  }

  static update(
    id: number,
    updateFunctionalUnitDto: UpdateFunctionalUnitDTO,
  ): Promise<FunctionalUnitDTO> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )
      configs.data = updateFunctionalUnitDto
      axios(configs, resolve, reject)
    })
  }

  static delete(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )
      axios(configs, resolve, reject)
    })
  }
}
